import { render, staticRenderFns } from "./ui-time.vue?vue&type=template&id=6d880c78&scoped=true&"
import script from "./ui-time.vue?vue&type=script&lang=js&"
export * from "./ui-time.vue?vue&type=script&lang=js&"
import style0 from "./ui-time.vue?vue&type=style&index=0&id=6d880c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d880c78",
  null
  
)

export default component.exports